import { render, staticRenderFns } from "./UniverseSelector.vue?vue&type=template&id=304b8a26&scoped=true"
import script from "./UniverseSelector.vue?vue&type=script&lang=ts"
export * from "./UniverseSelector.vue?vue&type=script&lang=ts"
import style0 from "./UniverseSelector.vue?vue&type=style&index=0&id=304b8a26&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304b8a26",
  null
  
)

export default component.exports